module.exports = __webpack_public_path__ + "static/media/arrow-dogweb-down-white.0f6d0a4b.svg";